export default __webpack_public_path__ + "static/media/corpu.78cc81a5.png";